// authService.js

import { clearLocalStorage } from "../../utilities/mixin";
import api from "./api";
import { login, signIn } from "./endPoints";

const authService = {
  async validateCredentials(userCredentials) {
    const response = await api.post(login, userCredentials);
    
    // Store token and user info
    localStorage.setItem("token", response.data.data.token);
    localStorage.setItem("currentUser", response.data.data.id);
    
    // Store user role for role-based access control
    if (response.data.data.role) {
      localStorage.setItem("userRole", response.data.data.role);
    }
    
    // Store user email for reference
    if (response.data.data.email) {
      localStorage.setItem("userEmail", response.data.data.email);
    }
  },

  // Static login helper - keeps backward compatibility with validateCredentials
  async login(credentials) {
    // In a real app you'd call the API:
    // const response = await api.post(login, credentials);
    // For now use the local mock flow to set a static token/user
    await this.validateCredentials(credentials);
    return this.getCurrentUser();
  },

  logout() {
    clearLocalStorage();
    window.location.href = "/";
  },

  getCurrentUser(key = "currentUser") {
    const userString = localStorage.getItem(key);
    if (!userString) return null;

    try {
      return JSON.parse(userString);
    } catch (error) {
      console.error("Error parsing user data from localStorage:", error);
      return null;
    }
  },

  // Get current user's role
  getCurrentUserRole() {
    return localStorage.getItem("userRole") || "employee";
  },

  // Check if current user is admin
  isAdmin() {
    return this.getCurrentUserRole() === "admin";
  },

  async signUp(param) {
    return await api.post(signIn, param);
  },
};

export default authService;
